import App from 'app/app.js';

function PortraitIdFormatterService() {
  this.format = (portraitId) => {
    let input = portraitId ? portraitId.toUpperCase() : '';

    // trim start:
    input = input.replace(/^[^A-Z0-9]+/, '');

    const isEV = this.isEV(input);

    if (!isEV && input.length > 4) {
      // trim end:
      input = input.replace(/^([A-Z0-9]{4})([- ]?)([A-Z0-9]{0,6}).*/, '$1$2$3');
      // autoformat:
      if (input.includes('-') || input.includes(' ')) {
        input = input.replace(/^([A-Z0-9]{4})[- ]?([A-Z0-9]{4}).*/, '$1-$2');
      }
    } else {
      // trim end:
      input = input.replace(/[^A-Z0-9]+$/, '');
    }

    return input.slice(0, isEV ? 9 : 10);
  };

  this.isEV = (input) => input.match(/^(EVC|EVT)/) !== null;

  this.isFormattedPortraitId = (input) => /^[A-Z0-9]{4}-[A-Z0-9]{4}$/.test(input?.toUpperCase());

  this.validate = (input) => {
    if (!input) {
      return false;
    }

    const upper = input.toUpperCase();

    if (!/^[A-Z0-9-]+$/.test(upper)) return false;

    if (this.isEV(upper) || upper[4] === '-') return upper.length === 9;

    if (upper.includes('-')) return false;

    return upper.length === 8 || upper.length === 10;
  };

  this.checkAccessCode = function (accessCode) {
    return accessCode.replace(/[^a-zA-Z0-9]/g, '');
  };
}

App.service('PortraitIdFormatterService', [PortraitIdFormatterService]);
